import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { DashboardArrangePage } from '~/features/insights/edit/arrange-dashboard';

/** Arrange insights for the Dashboard: the one place its layout changes. */
function ArrangeRoute(): ReactElement {
  return <DashboardArrangePage />;
}

export const Route = createFileRoute('/_app/dashboard/arrange')({ component: ArrangeRoute });
